import * as types from './actionTypes'

const initialState = {
    planning: {},
    events: [],
    filters: [],
    colors: [],
    isLoading: false
}

export default (state = initialState, action) => {
    switch (action.type) {
        case types.PLANNING_FETCH_SUCCESS:
            return {
                ...state,
                planning: action.planning ? {
                    ...action.planning
                } : null
            }

        case types.PLANNING_FETCH_FAILED:
            return {
                ...state
            }

        case types.UPDATE_PLANNING:
            return {
                ...state,
                isLoading: true
            }

        case types.UPDATE_PLANNING_SUCCESS:
            return {
                ...state,
                isLoading: false,
                planning: {
                    ...action.planning
                }
            }

        case types.UPDATE_PLANNING_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.PLANNING_DATA_FETCH:
            return {
                ...state,
                isLoading: true
            }

        case types.PLANNING_DATA_FETCH_SUCCESS:
            return {
                ...state,
                isLoading: false,
                events: [ ...action.data.events ],
                filters: [ ...action.data.filters ],
                colors: [ ...action.data.colors ]
            }

        case types.PLANNING_DATA_FETCH_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.PLANNING_EVENT_CHANGE:
            return {
                ...state,
                isLoading: true
            }

        case types.PLANNING_EVENT_CHANGE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                events: [ ...action.data.events ],
                filters: [ ...action.data.filters ],
                colors: [ ...action.data.colors ]
            }

        case types.PLANNING_EVENT_CHANGE_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.SET_COLORS:
            return {
                ...state,
                isLoading: true
            }

        case types.SET_COLORS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                planning: { ...action.planning }
            }

        case types.SET_COLORS_FAILED:
            return {
                ...state,
                isLoading: false
            }

		case types.PLANNING_DELETE:
            return {
                ...state,
                isLoading: true
            }

        case types.PLANNING_DELETE_SUCCESS:
            return {
                ...state,
				planning: null
            }

        case types.PLANNING_DELETE_FAILED:
            return {
                ...state,
                isLoading: false
            }

		case types.PLANNING_RESET:
            return {
                ...initialState
            }

        default:
            return state
    }
}
